export const applyTheme = theme => ({
  type: 'APPLY_THEME',
  theme: theme
})

export const toggleMode = mode => ({
  type: 'TOGGLE_MODE',
  mode: mode
})
